import { render, staticRenderFns } from "./ElevenPrizesList2019.vue?vue&type=template&id=202dc488&scoped=true"
import script from "./ElevenPrizesList2019.vue?vue&type=script&lang=js"
export * from "./ElevenPrizesList2019.vue?vue&type=script&lang=js"
import style0 from "./ElevenPrizesList2019.vue?vue&type=style&index=0&id=202dc488&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202dc488",
  null
  
)

export default component.exports